import React , {useEffect}  from "react";
import {
  Marker,
  GoogleMap,
  useJsApiLoader
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "65vh",
};

const center = { lat:10.793190, lng: 78.686676 }

function GoogleMapPage() {
  const { isLoaded } = useJsApiLoader({
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
      'Access-Control-Allow-Methods': 'OPTIONS,POST',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': '*',
    },
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyBoGn288OHR9wWyF669KeD7at3H7qhPuiI",
  })

  const [map, setMap] = React.useState(null)
  const [markerPosition, setMarkerPosition] = React.useState(null);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  useEffect(() => {
    // Retrieve the values from localStorage
    const storedLat = localStorage.getItem('servicereglat');
    const storedLng = localStorage.getItem('servicereglng');

    if (storedLat && storedLng) {
      // Update the marker position if values are available in localStorage
      setMarkerPosition({ lat: parseFloat(storedLng), lng: parseFloat(storedLat) });
    }
  }, []);

  return isLoaded ? (
    <div style={{height: "400px"}}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={markerPosition}
        zoom={5}
        onUnmount={onUnmount}
      >
         <Marker position={markerPosition} />
      </GoogleMap>
    </div>
  ) : <></>
}

export default React.memo(GoogleMapPage);
